import React, { useState } from "react";
import { useParams } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import { useWindowSize } from "../../../../../Helpers";
import "./style.scss";
import LinearGradientProgressBar from "@components/LinearGradientProgressBar";
import StickyButton from "../../../../../components/StickyButton";
import PagesHeader from "@components/PagesHeader";
import BrandLogo from "@components/BrandLogo";
import VideoPlayer from "@components/VideoPlayer";
import StickyContent from "@components/StickyContent";
import Button from "@components/Button";
import NiceModal from "@ebay/nice-modal-react";
import UltraInsider from "@pages/UltraInsider";
import DOMPurify from "dompurify";

export default function QuizVideo({
  currentQuestion,
  setCurrentQuestion,
  setAnswers,
  answers,
  sendAnswers,
}) {
  const { ident } = useParams();
  const { width } = useWindowSize();
  const queryClient = useQueryClient();
  const gameQuestionsQuery = queryClient.getQueryData([
    "game-questions",
    ident,
  ]);
  const XGA = width >= 1020;
  const [disabled, setDisabled] = useState(true);
  const [secondsWatched, setSecondsWatched] = useState(false);
  const isUltraInsider =
    location.pathname.includes("/ultra-insider") ||
    location.pathname.includes("/ultrainsider");

  const CheckAnswers = () => {
    setDisabled(false);
  };

  const handleNextButtonClick = () => {
    const currentQuestionIdent =
      gameQuestionsQuery.content[currentQuestion].ident;
    setDisabled(true);
    setSecondsWatched(0);

    if (gameQuestionsQuery.content[currentQuestion]?.includeInAnswers) {
      setAnswers((prevAnswers) => {
        return [
          ...prevAnswers,
          {
            question_ident: currentQuestionIdent,
            answer_ident: "true",
          },
        ];
      });
    }

    setCurrentQuestion(currentQuestion + 1);
  };

  return (
    <section
      className={`game-page quiz-video-mechanics ${ident} ${
        isUltraInsider ? "ultra-insider" : ""
      }`}
    >
      <div>
        <PagesHeader back>
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(gameQuestionsQuery?.title),
            }}
          ></p>
        </PagesHeader>
        <div className="main-game-wrppaer-video">
          <div className="desktop-wrapper">
            <LinearGradientProgressBar
              value={currentQuestion / gameQuestionsQuery.content.length}
            />
            <div className="game-question">
              <h2
                className="question"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(gameQuestionsQuery.content[currentQuestion].question),
                }}
              />
            </div>
          </div>
          <div className="side-img">
            <BrandLogo brands={gameQuestionsQuery?.brands} />
            <VideoPlayer
              placeholder={
                gameQuestionsQuery.content[currentQuestion]?.placHolder
              }
              videoSrc={gameQuestionsQuery.content[currentQuestion]?.video}
              onTimeWatchedFunction={CheckAnswers}
              onTimeWatchedFunctionTriger={
                gameQuestionsQuery.content[currentQuestion]?.videoTime
              }
              secondsWatched={secondsWatched}
              setSecondsWatched={setSecondsWatched}
              className="video-player"
            />
            {XGA && (
              <StickyContent>
                <div className="desktop-buttons">
                  {ident === "ultrainsider_vuse_fragrance_2025" && (
                    <Button
                      btnClass="outline yellow"
                      action={() =>
                        NiceModal.show("vuse-fragrance-2025-modal", {
                          ultraInsider: true,
                        })
                      }
                    >
                      Inhaltsstoffe ansehen
                    </Button>
                  )}
                  <Button action={handleNextButtonClick} disabled={disabled}>
                    {gameQuestionsQuery.content[currentQuestion]
                      .nextButtonCopy ?? "Nächste"}
                  </Button>
                </div>
              </StickyContent>
            )}
          </div>
        </div>
      </div>
      {!XGA && (
        <div className="mobile-buttons">
          {ident === "ultrainsider_vuse_fragrance_2025" && (
            <StickyButton
              btnClass="outline yellow"
              action={() =>
                NiceModal.show("vuse-fragrance-2025-modal", {
                  ultraInsider: true,
                })
              }
            >
              Inhaltsstoffe ansehen
            </StickyButton>
          )}
          <StickyButton action={handleNextButtonClick} disabled={disabled}>
            {gameQuestionsQuery.content[currentQuestion].nextButtonCopy ??
              "Nächste"}
          </StickyButton>
        </div>
      )}
    </section>
  );
}
